//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DistributionListsHeader',
  props: {
    pageName: {
      type: String,
      default: 'Distribution Lists'
    }
  },
  data() {
    return {
      searchTerm: '',
      refreshing: '',
      display: {
        distributionLists: ['new-distribution-list', 'refresh'],
        distributionListAdd: ['list'],
        distributionListEdit: ['list']
      }
    }
  },
  computed: {
    ...mapGetters({
      isDesktop: 'breakpoints/desktop',
      distributionListSearchParams: 'distributionLists/getDistributionListSearchParams',
      distributionListFilterOptions: 'distributionLists/getDistributionListFilterOptions'
    }),
    isRefreshing() {
      return this.refreshing !== ''
    },
    showSearch() {
      // Only show search on the main distribution lists index page
      return this.$route.name === 'distribution-lists'
    }
  },
  watch: {
    distributionListSearchParams: {
      handler(newParams) {
        this.searchTerm = newParams.name || ''
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      fetchDistributionLists: 'distributionLists/fetchDistributionLists',
      startLoading: 'global/startLoading',
      stopLoading: 'global/stopLoading',
      setDistributionListFilter: 'distributionLists/setDistributionListFilter'
    }),
    async handleAction(action) {
      switch (action) {
        case 'new-distribution-list':
          this.$router.push({ name: 'distribution-lists-add' })
          break
        case 'list':
          this.$router.push({ name: 'distribution-lists' })
          break
        case 'refresh':
          this.refreshing = 'refresh'
          this.startLoading()
          this.setDistributionListFilter('')
          this.clearSearch()
          await this.fetchDistributionLists({
            searchParams: this.distributionListSearchParams,
            limit: this.distributionListFilterOptions.listLimit,
            skip: this.distributionListFilterOptions.listSkip,
            sortby: this.distributionListFilterOptions.sortField
          })
          this.refreshing = ''
          this.stopLoading()
          break
        default:
          break
      }
    },
    clearSearch() {
      this.searchTerm = ''
      if (this.$refs.search) {
        this.$refs.search.newValue = ''
      }
      this.searchDistributionLists('')
    },
    searchDistributionLists(searchTerm) {
      this.searchTerm = searchTerm

      // Update the search parameters in the Vuex store - only search by name
      const updatedSearchParams = {
        name: searchTerm,
        organization: '',
        participant: ''
      }

      this.$store.commit('distributionLists/setDistributionListSearchParams', updatedSearchParams)

      // Fetch the updated distribution lists
      this.fetchDistributionLists({
        searchParams: updatedSearchParams,
        limit: this.distributionListFilterOptions.listLimit,
        skip: this.distributionListFilterOptions.listSkip,
        sortby: this.distributionListFilterOptions.sortField
      })
    },
    showButton(btn) {
      switch (this.$route.name) {
        case 'distribution-lists':
          return this.display.distributionLists.includes(btn)
        case 'distribution-lists-add':
          return this.display.distributionListAdd.includes(btn)
        case 'distribution-lists-id-edit':
          return this.display.distributionListEdit.includes(btn)
        default:
          return false
      }
    }
  }
}
